import { render, staticRenderFns } from "./ClientAdmin.vue?vue&type=template&id=7d35660d&scoped=true&"
import script from "./ClientAdmin.vue?vue&type=script&lang=js&"
export * from "./ClientAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d35660d",
  null
  
)

export default component.exports